/**
 * MoonPay specific events.
 */
export enum MoonpayEventName {
  MOONPAY_GEOCHECK_COMPLETED = 'MoonPay Geocheck Completed',
  MOONPAY_TRANSACTION_CREATED = 'MoonPay Transaction Created',
  MOONPAY_TRANSACTION_FAILED = 'MoonPay Transaction Failed',
  MOONPAY_TRANSACTION_UPDATED = 'MoonPay Transaction Updated',
}
